import interceptor from '@/plugins/interceptor';
const pathController = '/Stuff'

export default {
  state: () => ({
    
  }),
  mutations: { 
  },
  actions: {
    async stuff_postConsultation(_,obj) {
      return await interceptor.authenticate.post(`${process.env.VUE_APP_API_LMS_URL}${pathController}/consultation`,obj);
    },
    async stuff_onboarding() {
      return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_URL}${pathController}/onboarding`);
    },
    async preRegistration_creationOptions() {
      return await interceptor.authenticate.get(`${process.env.VUE_APP_API_LMS_INSCRIPTION_URL}${pathController}/creationOptions`);
    }
  }
}
